module.exports = __webpack_public_path__ + "img/SLT_0785-Bearbeitet.6e7a4b03.jpg";